import { pxToRem, themeGet } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const ButtonContainer = styled.button `
  --toggle-button-color: ${themeGet('colors.primary.400')};
  --toggle-button-transition-duration: 175ms;

  position: relative;
  flex-shrink: 0;
  width: ${pxToRem(28)};
  height: ${pxToRem(24)};
  padding: ${pxToRem(4)};
  border: none;
  outline: none;
  cursor: pointer;
  background-color: transparent;
  border-radius: ${themeGet('borderRadius.md')};
  transition: background-color var(--toggle-button-transition-duration) ease-in-out;

  &:hover {
    background-color: ${themeGet('colors.background.100')};
  }

  ${(props) => props.$open &&
    `
    --toggle-button-color: ${themeGet('colors.primary.800')};
  `}
`;
export const OuterBox = styled.div `
  width: 100%;
  height: 100%;
  border-radius: ${pxToRem(5)};
  border: ${pxToRem(2)} solid var(--toggle-button-color);
  transition: border-color var(--toggle-button-transition-duration) ease-in-out;
`;
export const InnerBox = styled.div `
  overflow: hidden;
  position: relative;
  height: 100%;
  width: ${pxToRem(6)};
  margin-left: ${(props) => props.$side === 'right' && 'auto'};
  border-left: ${(props) => (props.$side === 'left' ? 'none' : `${pxToRem(2)} solid var(--toggle-button-color)`)};
  border-right: ${(props) => (props.$side === 'right' ? 'none' : `${pxToRem(2)} solid var(--toggle-button-color)`)};
  transition: border-color var(--toggle-button-transition-duration) ease-in-out;

  &::after {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    height: 100%;
    width: ${pxToRem(6)};
    background-color: var(--toggle-button-color);
    transition:
      transform var(--toggle-button-transition-duration) ease-in-out,
      background-color var(--toggle-button-transition-duration) ease-in-out;

    --translate-x: ${(props) => (props.$side === 'right' ? '100%' : '-100%')};

    transform: translateX(${(props) => (props.$open ? '0%' : 'var(--translate-x)')});
  }
`;
